export interface activityIdMapType {
    [key: string]: number;
}

export const activityIdMap = {
    us: 80,
    ca: 81,
};
